/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddInventoryWriteOffDto as DigiworkMaitreDPosDtoWriteOffsAddInventoryWriteOffDto } from '../../models/Digiwork/MaitreD/Pos/DTO/WriteOffs/add-inventory-write-off-dto';
import { InventoryWriteOffDto as DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto } from '../../models/Digiwork/MaitreD/Pos/DTO/WriteOffs/inventory-write-off-dto';

export interface AddInventoryWriteOff$Params {
  inventoryId: string;
      body?: DigiworkMaitreDPosDtoWriteOffsAddInventoryWriteOffDto
}

export function addInventoryWriteOff(http: HttpClient, rootUrl: string, params: AddInventoryWriteOff$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto>> {
  const rb = new RequestBuilder(rootUrl, addInventoryWriteOff.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto>;
    })
  );
}

addInventoryWriteOff.PATH = '/api/inventories/{inventoryId}/write-offs';
